export default "__VITE_ASSET__DnSrQ0Az__"